import React from "react";
import StudentHeader from "./components/StudentHeader";
import StudentSidebar from "./components/StudentSidebar";
import Loader from "../../components/Loader/Loader";
import { StudentSessionProvider, useStudentSession } from "./context/StudentSessionContext";
import { StudentThemeProvider, useStudentTheme } from "./context/StudentThemeContext";
import "./StudentPortal.css";

// Every page's own data-fetching effect fires as soon as it mounts, with no
// idea whether the session bootstrap (which stores organization-id/session-id/
// student_id in localStorage for studentApi.js's interceptor to attach) has
// finished yet. Gating `children` behind `isLoading` here — instead of in
// every single feature's hook — means no page's own request can ever race
// ahead of that bootstrap and get sent without those headers.
const StudentPortalContent = ({ children }) => {
  const { isLoading } = useStudentSession();
  // Only set when the student has actually picked a custom accent color —
  // undefined otherwise, so the shell's own stylesheet default (#0070D8)
  // applies untouched. See StudentThemeContext.
  const { themeStyle } = useStudentTheme();

  return (
    <div className="student-portal-shell" style={themeStyle}>
      <div className="sp-shell-sidebar">
        <StudentSidebar />
      </div>
      <div className="sp-shell-header">
        <StudentHeader />
      </div>
      <div className="sp-shell-content">
        <main className="sp-shell-main">{isLoading ? <Loader /> : children}</main>
      </div>
    </div>
  );
};

// Mirrors the structural shape of src/containers/TheLayout.js (header slot /
// sidebar slot / content slot) without importing or modifying it, rendering
// StudentHeader/StudentSidebar instead. Every wrapper class here is its own
// (`sp-shell-*`), not the staff layout's `header-layout`/`sidebar-layout`/
// `content-wrapper`/`content-container` — those carry real positioning rules
// in main.css (fixed widths/offsets tuned for the staff header's height)
// that broke this layout when reused. `.student-portal-shell` and
// everything under it is fully self-contained, so none of the staff app's
// layout CSS — or this module's own — can affect the other.
const StudentPortalLayout = ({ children }) => (
  <StudentThemeProvider>
    <StudentSessionProvider>
      <StudentPortalContent>{children}</StudentPortalContent>
    </StudentSessionProvider>
  </StudentThemeProvider>
);

export default StudentPortalLayout;
